export default __webpack_public_path__ + "static/zbenice-logo-bf8f62a2aa42af27392d0546b2779449.png";